import script from "./CompaniesSubscriptions.vue?vue&type=script&setup=true&lang=js"
export * from "./CompaniesSubscriptions.vue?vue&type=script&setup=true&lang=js"

import "./CompaniesSubscriptions.vue?vue&type=style&index=0&id=d00e54ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d00e54ac"]])

export default __exports__